import {useState, useEffect } from 'react';
import axios from 'axios';
// import AuthContext from './AuthContext';
import { v4 as uuidv4 } from 'uuid';
import _ from 'lodash';

export const getFormSection = (form, sectionName) => {
  const section = _.find(form, (o) => _.has(o, sectionName));
  const index = _.findIndex(form, (o) => _.has(o, sectionName));

  // the nested value, or a default empty object
  return _.get(section, sectionName, {});
};

// const Authentication = ({ props }) => {
//     const [auth, setAuth] = useState({
//         token: localStorage.getItem('token') || null,
//         isAuthenticated: false,
//         loading: true,
//         msg: null
//     });
//     const login = async (credentials) => {
//         let dataResponse = {};
//         try {
//             const t = _.get(credentials, 'token.token', "");
//             const response = await fetch('/wp-json/unlock/custom-auth/v1/login', {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                 },
//                 body: JSON.stringify(
//                     {'token': t },
//                 )
//             })  .then(response => {
//                     if (!response.ok) throw new Error('Network response was not ok');
//                     return response.json();
//                 })
//                 .then(data => {
//                     // console.log('✅ Response from API:', data);
//                     dataResponse = data;
//                 })
//                 .catch(error => {
//                     // console.error('❌ API Error:', error);
//                 });
//         const token = dataResponse.token;
//         const success = dataResponse.success;
//         const message = dataResponse.message;
//         const valid = dataResponse.valid;
//         const uuid = dataResponse.uuid;
//         if (success && valid) {
//             localStorage.setItem('token', token);
//             localStorage.setItem('UUID', uuid);

//             setAuth({
//                 token,
//                 isAuthenticated: true,
//                 loading: false,
//                 msg: message
//             });
//             window.location.href = '/';
//             return true;
//         }
//         setAuth({
//             token: null,
//             isAuthenticated: false,
//             loading: false,
//             msg: message
//         });
//         return false;
//         } catch (error) {
//         // console.error('Login failed:', error);
//         return false;
//         }
//     };

//     const logout = () => {
//         localStorage.removeItem('token');
//         setAuth({
//             token: null,
//             isAuthenticated: false,
//             loading: false,
//             msg: ""
//         });
//         // Redirect to home page
//         window.location.href = '/home';
//     }
// }